<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-primary">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'trips.listing' }"
          >Trips</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4" v-if="form">
      <div class="display-2 font-weight-bold my-6 text-capitalize">
        Update Trip
      </div>

      <v-form ref="form" v-if="form" class="place-form">
        <v-row class="update-trip__content">
          <!-- Trip Form -->
          <v-col class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0">
            <h3 class="py-5 primary--text">Trip Information</h3>

            <label class="text-field-label">Name</label>
            <v-text-field
              flat
              solo
              required
              class="mt-2"
              v-model="form.name"
              :error-messages="form.$getError('name')"
              :loading="loading"
            ></v-text-field>

            <label class="text-field-label">Type</label>
            <v-select
              class="mt-2"
              v-model="form.types"
              :items="tripTypes"
              :loading="fetchingTripTypes"
              filled
              multiple
              item-text="name"
              item-value="id"
              :error-messages="form.$getError('types')"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getTripTypes()"
                  :loading="fetchingTripTypes"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-select>

            <label class="text-field-label">Accommodation Type</label>
            <v-select
              class="mt-2"
              v-model="form.accommodation_types"
              :items="accommodationTypes"
              :loading="fetchingAccommodationTypes"
              filled
              multiple
              item-text="name"
              item-value="id"
              :error-messages="form.$getError('accommodation_types')"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getAccommodationTypes()"
                  :loading="fetchingAccommodationTypes"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-select>

            <v-divider></v-divider>

            <h3 class="py-5 primary--text">Itinerary Information</h3>

            <label class="text-field-label">Origin</label>
            <v-text-field
              flat
              solo
              readonly
              class="mt-2"
              v-model="form.origin_address"
              :error-messages="form.$getError('destination')"
              :loading="loading"
              persistent-hint
              hint="Note: Origin will be base on the origin
              of the first day"
            ></v-text-field>

            <label class="text-field-label">Destination</label>
            <v-text-field
              flat
              solo
              readonly
              class="mt-2"
              v-model="form.destination_address"
              :error-messages="form.$getError('destination')"
              :loading="loading"
              persistent-hint
              hint="Note: Destination will be base on the last stop
              of the provided itinerary"
            ></v-text-field>

            <ItineraryTemplate
              :itineraryTemplate="form.itinerary_activity_template_ids"
              :errorMessage="form.$getError('itinerary_activity_template_ids')"
              @add="addItineraryTemplate"
              @remove="removeItineraryTemplate($event)"
            ></ItineraryTemplate>

            <div class="mt-5 d-flex">
              <v-btn
                color="normal"
                class="mr-5 px-6"
                height="40px"
                width="47%"
                :loading="form.$busy"
                :to="{ name: 'trips' }"
                >Back</v-btn
              >

              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                class="px-6"
                height="40px"
                width="47%"
                :loading="form.$busy"
                @click="saveTripDetails"
                >Save</v-btn
              >
            </div>
          </v-col>

          <v-col class="col-md-5 offset-md-1 col-sm-12 col-xs-12 mt-6 pl-10">
            <h3 class="py-5 primary--text">Media Information</h3>
            <trip-media-form
              :tripMedia="tripMedia"
              :mediaLoading="mediaLoading"
              updateImage
              @change="mediaChange"
              @delete="removeMedia"
            />

            <!-- <v-divider></v-divider> -->

            <!--            <PointOfInterest-->
            <!--              :pointOfInterest="form.point_of_interests"-->
            <!--              :pointOfInterestAddress="form.point_of_interests_address"-->
            <!--              @add="addPointOfInterest"-->
            <!--              @remove="removePointOfInterest($event)"-->
            <!--              @update="updatePointOfInterest($event)"-->
            <!--            ></PointOfInterest>-->
            <!--
            <h3 class="py-5 primary--text">Points of Interest</h3>
            <label class="text-field-label">Landmarks</label>
            <v-autocomplete
              class="mt-2"
              v-model="form.point_of_interests.place_ids"
              :items="landmarks"
              :loading="fetchingLandmarks"
              filled
              multiple
              item-text="name"
              item-value="id"
              :error-messages="form.$getError('place_ids')"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getLandmarks()"
                  :loading="fetchingLandmarks"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>

            <label class="text-field-label">Shops</label>
            <v-autocomplete
              class="mt-2"
              v-model="form.point_of_interests.place_ids"
              :items="stores"
              :loading="fetchingStores"
              filled
              multiple
              item-text="name"
              item-value="id"
              :error-messages="form.$getError('place_ids')"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getStores()"
                  :loading="fetchingStores"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>

            <label class="text-field-label">Restaurants</label>
            <v-autocomplete
              class="mt-2"
              v-model="form.point_of_interests.place_ids"
              :items="restaurants"
              :loading="fetchingRestaurants"
              filled
              multiple
              item-text="name"
              item-value="id"
              :error-messages="form.$getError('place_ids')"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getRestaurants()"
                  :loading="fetchingRestaurants"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
            -->
          </v-col>
        </v-row>
      </v-form>
      <!-- End of Trip Form -->
    </div>

    <ConfirmModal
      v-model="showDeleteModal"
      title="Delete Trip Image"
      :message="deleteMessage"
      @cancel="showDeleteModal = false"
      @confirm="deleteTripImage"
    ></ConfirmModal>
  </div>
</template>

<script>
/* eslint-disable camelcase */

import TripMediaForm from './components/TripMediaForm'
import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ConfirmModal from '@/components/modals/ConfirmModal'
import ItineraryTemplate from './components/ItineraryTemplate'

import Form from '@/utils/form'
import { mapState, mapActions } from 'vuex'
import TripForm from '@/utils/mixins/TripForm'

export default {
  name: 'UpdateTrip',

  mixins: [ControlsMixin, TripForm],

  components: {
    AppBarNavIcon,
    TripMediaForm,
    ConfirmModal,
    ItineraryTemplate
  },

  data() {
    return {
      form: {
        origin: {},
        origin_address: '',
        destination: {},
        destination_address: '',
        point_of_interests: {
          place_ids: []
        }
      },
      mediaLoading: false,
      imageId: null,
      showDeleteModal: false
    }
  },

  computed: {
    ...mapState({
      trip: state => state.trip.tripDetails,
      tripMedia: state => state.trip.tripMedia,
      itineraryDetails: state => state.itinerary.itineraryDetails
    }),

    deleteMessage() {
      return 'Are you sure you want to delete this image?'
    }
  },

  watch: {
    async 'form.itinerary_activity_template_ids'() {
      this.form.$busy = true

      if (!this.form.itinerary_activity_template_ids[0]) {
        this.form.$busy = false
        return false
      }

      try {
        const [firstRoute, lastRoute] = await Promise.all([
          this.getItineraryDetails(
            this.form.itinerary_activity_template_ids[0]
          ),
          this.getItineraryDetails(
            this.form.itinerary_activity_template_ids.slice(-1)[0]
          )
        ])

        const origin = firstRoute.data.stops[0]
        const destination = lastRoute.data.stops?.slice(-1)[0]

        this.form.origin_address = origin?.places_address ?? ''
        this.form.origin = origin?.google_places_id ?? ''

        this.form.destination_address = destination?.places_address ?? ''
        this.form.destination = destination?.google_places_id ?? ''

        this.form.$busy = false
      } catch (err) {
        this.form.$busy = false
        this.setAlert({
          message: err.response.data.message,
          color: 'error'
        })
      }
    }
  },

  created() {
    this.clearTripDetails()
    this.getDropdownOptions()
    this.form = new Form(this.trip)
    this.getTrip()
  },

  methods: {
    ...mapActions({
      updateTrip: 'trip/updateTrip',
      clearTripDetails: 'trip/clearTripDetails',
      getTripDetails: 'trip/getTripDetails',
      getTripMedia: 'trip/getTripMedia',
      addTripMedia: 'trip/addTripMedia',
      clearTripMedia: 'trip/clearTripMedia',
      deleteTripMedia: 'trip/deleteTripMedia',
      getItineraryDetails: 'itinerary/getItineraryDetails',
      setAlert: 'alert/setAlert'
    }),

    addItineraryTemplate() {
      this.form.itinerary_activity_template_ids.push('')
    },

    removeItineraryTemplate(index) {
      this.form.itinerary_activity_template_ids.splice(index, 1)
    },

    updateItineraryTemplate(template) {
      this.form.itinerary_activity_template_ids[template.id] = template.value
    },

    addPointOfInterest() {
      this.form.point_of_interests_address.push('')
      this.form.point_of_interests.push('')
    },

    removePointOfInterest(index) {
      this.form.point_of_interests_address.splice(index, 1)
      this.form.point_of_interests.splice(index, 1)
    },

    async getTrip() {
      this.loading = true
      await this.getTripDetails(this.$route.params.id)
      await this.getTripMedia(this.$route.params.id)

      // this.form = new Form(this.trip)
      this.form.id = this.trip.id
      this.form.name = this.trip.name
      this.form.types = this.trip.typeList
      this.form.accommodation_types = this.trip.accommodationList
      this.form.origin = this.trip.originPlacesId
      this.form.origin_address = this.trip.originFormatAddress
      this.form.destination = this.trip.destinationPlacesId
      this.form.destination_address = this.trip.destinationFormatAddress
      this.form.itinerary_activity_template_ids = this.trip.itineraryIds

      this.form.point_of_interests.place_ids = this.trip.point_of_interests?.map(
        points => points.place_id
      )

      this.loading = false
    },

    async mediaChange(files) {
      this.form.$busy = true
      this.form.$clearErrors()

      let data = new FormData()
      data.append('id', this.form.id)

      // Check if image is valid file
      if (files.length > 0) {
        let photoInfo = Object.values(files)
        photoInfo.forEach(function(item, index) {
          if (item instanceof File) {
            data.append('photos[' + index + ']', item)
          }
        })
      } else {
        data.append('photos', '')
      }

      this.addTripMedia(data)
        .then(() => {
          this.form.$busy = false
          this.setAlert({
            message: 'Images successfully updated!',
            color: 'success'
          })
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },

    removeMedia(mediaId) {
      this.imageId = mediaId
      this.showDeleteModal = true
    },

    async deleteTripImage() {
      this.mediaLoading = true

      let imageForm = new Form()
      imageForm.id = this.form.id
      imageForm.imageId = this.imageId

      this.deleteTripMedia(imageForm)
        .then(async () => {
          this.showDeleteModal = false
          this.mediaLoading = false
          this.imageId = null

          this.clearTripMedia()
          await this.getTripMedia(this.form.id)

          this.setAlert({
            message: 'Image successfully deleted!',
            color: 'success'
          })
        })
        .catch(err => {
          this.showDeleteModal = false
          this.mediaLoading = false

          this.setAlert({
            message: err.response.data.message,
            color: 'error'
          })
        })

      return true
    },

    async saveTripDetails() {
      this.form.$busy = true
      this.form.$clearErrors()

      let data = new FormData()
      data.append('_method', 'PUT')
      data.append('id', this.form.id)
      data.append('name', this.form.name)

      // Check if trip type is null
      if (this.form.types.length > 0) {
        let tripTypes = Object.values(this.form.types)
        tripTypes.forEach(function(item, index) {
          data.append('types[' + index + ']', item)
        })
      }

      // Check if accommodation type is null
      if (this.form.accommodation_types.length > 0) {
        let accommmodationTypes = Object.values(this.form.accommodation_types)
        accommmodationTypes.forEach(function(item, index) {
          data.append('accommodation_types[' + index + ']', item)
        })
      }

      // Check if point of interests is null
      if (this.form.point_of_interests !== null) {
        let poiList = this.form.point_of_interests.place_ids
        poiList.forEach(function(item, index) {
          data.append('point_of_interests[' + index + ']', item)
        })
      }

      // Check if origin is provided
      if (this.form.origin !== null) {
        data.append('origin', this.form.origin)
      }

      // Check if destination is provided
      if (this.form.destination !== null) {
        data.append('destination', this.form.destination)
      }

      // Check if itinerary template is null
      if (this.form.itinerary_activity_template_ids.length > 0) {
        let itineraryList = Object.values(
          this.form.itinerary_activity_template_ids
        )
        itineraryList.forEach(function(item, index) {
          data.append('itinerary_activity_template_ids[' + index + ']', item)
        })
      }

      this.updateTrip(data)
        .then(() => {
          this.form.$busy = false
          this.setAlert({
            message: 'Trip details successfully updated!',
            color: 'success'
          })
          this.$router.replace({ name: 'trips.listing' })
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.point-of-interest {
  display: flex;
  flex-direction: row;

  .autocomplete-field {
    width: 300px;
  }
}
</style>
